<template>
  <div id="app">
    <nav-bar />
    <main class="site-main">
      <router-view />
    </main>
    <footer-section />
  </div>
</template>

<script>
import NavBar from '@/components/common/NavBar.vue'
import FooterSection from '@/components/common/FooterSection.vue'

export default {
  name: 'App',
  components: { NavBar, FooterSection }
}
</script>
